<mat-card class="resume-card">
    <mat-card-header *ngIf="showTitle">
        <mat-card-subtitle>{{brand}} {{subBrand}}</mat-card-subtitle>
        <mat-card-subtitle class="version">{{version}} {{year}}</mat-card-subtitle>
        <mat-card-title>{{monthlyPayment | currency}} <span class="text-mensuales">Mensuales</span></mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div>
            <div class="resume-info">
                <span class="info-left">{{ 'Entidad de Seguro'}}</span>
                <span class="info-right">{{ stateName }}</span>
            </div>
            <div class="resume-info" *ngIf="isCredit">
                <span class="info-left"> {{ 'CREDIT.quoter.hitch' | translate }}:</span>
                <span class="info-right">{{ hitch |  currency }}</span>
            </div>
            <div class="resume-info" *ngIf="!isCredit">
                <span class="info-left">Pago inicial:</span>
                <span class="info-right">{{ ri |  currency }}</span>
            </div>

            <div *ngIf="purchaseValue && purchaseValue !== 0" class="resume-info">
                <span class="info-left">Valor de Compra:</span>
                <span class="info-right">{{ purchaseValue |  currency }}</span>
            </div>

            <div class="resume-info">
                <span class="info-left">Producto:</span>
                <span class="info-right">{{ concept || '----'}}</span>
            </div>
            <div class="resume-info">
                <span class="info-left">Plazo:</span>
                <span class="info-right">{{ period ? (period + ' meses') : '----'}}</span>
            </div>
        </div>
        <hr *ngIf="showTitle">
        <div>
            <div class="resume-info">
                <span class="info-left">Pago Inicial Total:</span>
                <span class="info-right">{{ (initialPayment | currency) || '----'}}</span>
            </div>
            <div class="resume-info" *ngIf="isCredit && annuity">
                <span class="info-left">{{ 'CREDIT.quoter.annuity' | translate }}:</span>
                <span class="info-right">{{ (annuity | currency) || '----'}}</span>
            </div>
            <div class="resume-info" *ngIf="isCredit && isBallon && ballon">
                <span class="info-left">Ballon:</span>
                <span class="info-right">{{ (ballon | percent: '1.2-2') || '----'}}</span>
            </div>
            <div *ngIf="appliedCode">
                <hr>
                <div class="resume-info code-apply">
                    <span class="info-left">Código promocional aplicado</span>
                    <mat-icon class="icon-check" matSuffix>check_circle</mat-icon>
                </div>
                <hr>
            </div>
            <div class="resume-info" *ngIf="!isCredit">
                <span class="info-left">Renta Mensual:</span>
                <span class="info-right">{{ (monthlyPayment | currency) || '----'}}</span>
            </div>
            <div class="resume-info" *ngIf="isCredit">
                <span class="info-left">{{ 'CREDIT.quoter.rate' | translate }}:</span>
                <span class="info-right">{{ (rate | percent: '1.2-2') || '----'}}</span>
            </div>
            <div class="resume-info" *ngIf="isCredit">
                <span class="info-left">{{ 'CREDIT.quoter.cat' | translate }}:</span>
                <span class="info-right">{{ (cat | percent: '1.2-2') || '----'}}</span>
            </div>

            <div class="resume-info">
                <span class="info-left">Aseguradora:</span>
                <span class="info-right">{{ insurance || '----' }}</span>
            </div>

        </div>
    </mat-card-content>
</mat-card>